import { render, staticRenderFns } from "./ProductRejectDetailsModal.vue?vue&type=template&id=5dece1e6&"
import script from "./ProductRejectDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProductRejectDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductRejectDetailsModal.vue?vue&type=style&index=0&id=5dece1e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports